import React, { useState } from "react";
import "./tutorialgallery.css";

// Mock data for the tutorial videos
const tutorialVideos = [
  {
    id: 1,
    title: "Journal 101",
    thumbnail:
      "https://cdn.loom.com/sessions/thumbnails/da8dfedae4da4169b3a72867435a5738-e905b25e79cc092e-full-play.gif",
    src: "https://www.loom.com/embed/da8dfedae4da4169b3a72867435a5738?sid=1a806ac8-d494-45b4-9f18-1da9d208553f", // Example YouTube Video ID
  },
  {
    id: 2,
    title: "Year Map 101",
    thumbnail:
      "https://cdn.loom.com/sessions/thumbnails/f3a9a75ad5454f4283a1e79a8c2b8063-5de5613f6f757499-full-play.gif",
    src: "https://www.loom.com/embed/f3a9a75ad5454f4283a1e79a8c2b8063?sid=39013e32-5433-4303-a805-deb97cafbe15",
  },
  {
    id: 3,
    title: "Week Planner 101",
    thumbnail:
      "https://cdn.loom.com/sessions/thumbnails/3bfbd3dedab54389a21b60b7e11378f1-0a6d55d422c5ae59-full-play.gif",
    src: "https://www.loom.com/embed/3bfbd3dedab54389a21b60b7e11378f1?sid=90b8132f-2107-4387-9ef4-bb635ebc8e70",
  },
  {
    id: 4,
    title: "Insights Hub 101",
    thumbnail:
      "https://cdn.loom.com/sessions/thumbnails/626a4cd8957049558d361a5afbfc85ec-9c03f161f2a0e943-full-play.gif",
    src: "https://www.loom.com/embed/626a4cd8957049558d361a5afbfc85ec?sid=aa61c2b5-343b-4f37-8037-83b4e126502a",
  },
  {
    id: 5,
    title: "The Art of Looking 101",
    thumbnail:
      "https://cdn.loom.com/sessions/thumbnails/01c24df40d9b40ffba8f693d6e19f836-e23681b4e604a800-full-play.gif",
    src: "https://www.loom.com/embed/01c24df40d9b40ffba8f693d6e19f836?sid=649a15c7-1098-42c3-acf8-c7960be1b1f6",
  },
];

export function TutorialGallery({ initial }) {
  const [selectedVideo, setSelectedVideo] = useState(initial || null);

  const handleSelectVideo = (video) => {
    setSelectedVideo(video);
  };

  const handleClosePlayer = () => {
    setSelectedVideo(null);
  };

  return (
    <div className={"pageContainer"}>
      <main className={"galleryGrid"}>
        {tutorialVideos.map((video) => (
          <div
            key={video.id}
            className={"videoThumbnail"}
            onClick={() => handleSelectVideo(video)}
          >
            <img src={video.thumbnail} alt={video.title} />
            <div className={"videoTitle"}>
              <h5>{video.title}</h5>
            </div>
          </div>
        ))}
      </main>

      {selectedVideo && (
        <div className={"modalOverlay"} onClick={handleClosePlayer}>
          <div
            className={`${"videoPlayer"} ${"prime"}`}
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking the video player
          >
            <button className={"closeButton"} onClick={handleClosePlayer}>
              &times;
            </button>
            <h3>{selectedVideo.title}</h3>
            <div className={"videoContent"}>
              <iframe
                src={selectedVideo.src}
                title={selectedVideo.title}
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%",
                }}
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
